import {
  Component,
  DoCheck,
  ElementRef,
  EventEmitter,
  inject,
  Inject,
  Input,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {BaseDetailComponent} from '../../common/BaseDetailComponent';
import {CustomerProductItemFull} from '../../../Models/CustomerProductItem/CustomerProductItemFull';
import {MatTableDataSource} from '@angular/material/table';
import {MatPaginator} from '@angular/material/paginator';
import {MatTabChangeEvent} from '@angular/material/tabs';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AccessibilityTypes, E015Attributes} from '../../../Models/CustomerProductItem/E015Attributes';
import {DAEAttributes} from '../../../Models/CustomerProductItem/DAEAttributes';
import {NgForm, NgModel} from '@angular/forms';
import {GetE015DefaultChargersCB} from '../../../Ope/CustomerProductItem/GetE015DefaultChargersCB';
import {CustomerProductItemService} from "../../../Services/Ope/CustomerProductItem.service";
import {BaseDialogComponent} from "../../common/BaseDialogComponent";
import {DelCustomerProductItemChirpstackCB} from "../../../Ope/CustomerProductItem/DelCustomerProductItemChirpstackCB";
import {ProductType} from "../../../Models/CustomerProductItem/ProductType";
import {ProductItemChargerRelationDTO} from "../../../Models/CustomerProductItem/ProductItemChargerRelationDTO";
import {ProductTypeChargerRelationDTO} from "../../../Ope/ProductType/ProductTypeChargerRelationDTO";

@Component({
  selector: 'app-customer-productItem-detail',
  templateUrl: './customerProductItemDetail.component.html',
  styleUrls: ['customerProductItemDetail.component.css']
})
export class CustomerProductItemDetailComponent extends BaseDetailComponent implements DoCheck {

  @Input('selectedRow') selectedRow?: any;
  @Input('editMode') editMode?: boolean;
  @Input('isOnChirpstack') isOnChirpstack!: boolean;
  @Output() close = new EventEmitter();
  @Output() refresh = new EventEmitter(this.selectedRow);
  @Output() validForm = new EventEmitter<boolean>();
  @ViewChild('updateForm') updateForm!: NgForm;

  // ***************************
  //   PAGINATION OPTIONS
  // ***************************
  readonly PAGESIZE_OPTIONS = [10, 20, 30];

  displayedColumns: string[] = ['name', 'power', 'taIndex' , 'count'];
  tableDataSource!: MatTableDataSource<ProductItemChargerRelationDTO>;

  private customerProductItemService = inject(CustomerProductItemService);

  @ViewChild('fileInput') fileInput!: ElementRef;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  @ViewChild('productItemE015Provider') productItemE015Provider!: NgModel;
  @ViewChild('e015StationId') e015StationId!: NgModel;
  @ViewChild('e015LocationAddress') e015LocationAddress!: NgModel;
  @ViewChild('e015LocationAddressType') e015LocationAddressType!: NgModel;
  @ViewChild('e015LocationZipCode') e015LocationZipCode!: NgModel;
  @ViewChild('e015LocationCity') e015LocationCity!: NgModel;
  @ViewChild('e015LocationProvince') e015LocationProvince!: NgModel;
  @ViewChild('e015LocationRegion') e015LocationRegion!: NgModel;
  @ViewChild('e015StationAccessibility') e015StationAccessibility!: NgModel;

  tabIndex = 0;

  dataDetail?: CustomerProductItemFull;

  expireBatteryDate?: Date | null;

  expireElectrodeDate?: Date | null;

  EUIRegex = /(?=^.{0,16}$)[0-9A-Fa-f]{16}|[0-9A-Fa-f}:]{22}[0-9A-Fa-f}]/g

  ngDoCheck() {
    this.validForm.emit(!this.updateForm?.invalid);


  }

  ngOnChanges(changes: SimpleChanges) {
    super.ngOnChanges(changes);

    // Overrides behavior in order to initialize datepickers
    if (changes.selectedRow && !!this.selectedRow) {
      this.initializeDates();
      this.initializeTable();

      this.resetProductItemDetailTab();
      // if (!!changes.selectedRow.previousValue && changes.selectedRow.previousValue.id !== changes.selectedRow.currentValue.id) {
      //
      // }
    }
    else if (changes.editMode && !!this.selectedRow) {
      if (!this.editMode) {
        this.resetProductItemDetailTab();
        this.initializeDates();
      }
      this.initializeTable();
    }
  }

  private resetProductItemDetailTab() {
    // if E015 is not enabled OR DAE is not enabled, switch to zero-tab
    if (this.tabIndex === 1 && !this.dataDetail?.hasDae) {
      this.tabIndex = 0;
    }
    if ((this.tabIndex === 2 || this.tabIndex === 3) && !this.dataDetail?.isE015) {
      this.tabIndex = 0;
    }
  }

  resetImage() {
    super.resetImage();
    if (!!this.dataDetail) {
      this.dataDetail.imageUrl = undefined;
    }

    if (!!this.fileInput) {
      this.fileInput.nativeElement.value = '';
    }
  }

  private initializeDates() {
    if (!!this.dataDetail && !!this.dataDetail.daeAttributes && !!this.dataDetail.daeAttributes.daeBatteryExpireDate) {
      this.expireBatteryDate = new Date(this.dataDetail.daeAttributes.daeBatteryExpireDate)
    } else {
      this.expireBatteryDate = null;
    }

    if (!!this.dataDetail && !!this.dataDetail.daeAttributes && !!this.dataDetail.daeAttributes.daeElectrodeExpireDate) {
      this.expireElectrodeDate = new Date(this.dataDetail.daeAttributes.daeElectrodeExpireDate)
    } else {
      this.expireElectrodeDate = null;
    }
  }

  private initializeTable() {
    if (!!this.dataDetail?.chargers) {
      this.tableDataSource = new MatTableDataSource<ProductItemChargerRelationDTO>(this.dataDetail?.chargers);
    } else {
      this.tableDataSource = new MatTableDataSource<ProductItemChargerRelationDTO>();
    }
    this.tableDataSource.paginator = this.paginator;
  }


  assignBattExpDate(beginDate: Date) {
    if (!!this.dataDetail && !!this.dataDetail.daeAttributes) {
      this.dataDetail.daeAttributes.daeBatteryExpireDate = (beginDate !== null) ? new Date(beginDate) : undefined;
    }

  }

  assignElectExpDate(beginDate: Date) {
    if (!!this.dataDetail && !!this.dataDetail.daeAttributes) {
      this.dataDetail.daeAttributes.daeElectrodeExpireDate = (beginDate !== null) ? new Date(beginDate) : undefined;
    }
  }

  createDAEObjects() {
    if (!!this.dataDetail && this.dataDetail.hasDae) {
      if (!(!!this.dataDetail.daeAttributes)) {
        // Create object
        console.log('Creating DAE Attrs');
        this.dataDetail.daeAttributes = new DAEAttributes();
      }
    }
  }

  createE015Objects() {
    if (!!this.dataDetail) {

      if (this.dataDetail.isE015) {

        if (!!this.productItemE015Provider) {
          this.updateForm.addControl(this.productItemE015Provider);
          this.updateForm.addControl(this.e015StationId);
          this.updateForm.addControl(this.e015LocationAddress);
          this.updateForm.addControl(this.e015LocationAddressType);
          this.updateForm.addControl(this.e015LocationZipCode);
          this.updateForm.addControl(this.e015LocationCity);
          this.updateForm.addControl(this.e015LocationProvince);
          this.updateForm.addControl(this.e015LocationRegion);
          this.updateForm.addControl(this.e015StationAccessibility);
        }


        if (!(!!this.dataDetail.e015Attributes)) {
          // Create object
          console.log('Creating E015 Attrs');
          this.dataDetail.e015Attributes = new E015Attributes();
        }
      } else {
        this.updateForm.removeControl(this.productItemE015Provider);
        this.updateForm.removeControl(this.e015StationId);
        this.updateForm.removeControl(this.e015LocationAddress);
        this.updateForm.removeControl(this.e015LocationAddressType);
        this.updateForm.removeControl(this.e015LocationZipCode);
        this.updateForm.removeControl(this.e015LocationCity);
        this.updateForm.removeControl(this.e015LocationProvince);
        this.updateForm.removeControl(this.e015LocationRegion);
        this.updateForm.removeControl(this.e015StationAccessibility);
      }


    }
  }


  tabChanges($event: MatTabChangeEvent) {

    // E015 Charger.ts
    if ($event.index === 3) {
      // @ts-ignore
      this.tableDataSource.paginator = this.paginator;
    }
  }

  addCharger() {

    const newCharger = new ProductItemChargerRelationDTO();

    const dialogRef = this.dialog.open(PutProductItemE015ChargerDialogComponent, {
      width: '600px',
      data: {
        charger: newCharger,
        isNewCharger: true
      }
    });

    dialogRef.afterClosed().subscribe(
        (res: boolean) => {
          if (res) {

            if (!!this.dataDetail) {
              if (!(!!this.dataDetail.chargers)) {
                this.dataDetail.chargers = new Array<ProductItemChargerRelationDTO>();
              }

              this.dataDetail.chargers.push(newCharger);
              this.initializeTable();
            }
          }
        }, (error: string) => {
          console.log(error);
        }
    );

  }

  updateCharger(element: ProductItemChargerRelationDTO) {
    const newCharger = JSON.parse(JSON.stringify(element));

    const dialogRef = this.dialog.open(PutProductItemE015ChargerDialogComponent, {
      width: '600px',
      data: {
        charger: newCharger,
        isNewCharger: false
      }
    });

    dialogRef.afterClosed().subscribe(
        (res: boolean) => {
          if (res) {

            if (!!this.dataDetail && !!this.dataDetail.e015Attributes) {
              if (!(!!this.dataDetail.chargers)) {
                this.dataDetail.chargers = new Array<ProductItemChargerRelationDTO>();
              }

              const idx = this.dataDetail.chargers.findIndex(el => el.id === newCharger.id);

              if (idx !== -1) {
                this.dataDetail.chargers[idx] = newCharger;

                this.initializeTable();
              }

            }
          }
        }, (error: string) => {
          console.log(error);
        }
    );
  }

  deleteCharger(element: ProductItemChargerRelationDTO) {
    if (!!this.dataDetail && !!this.dataDetail.e015Attributes && !!this.dataDetail.chargers) {
      this.dataDetail.chargers = this.dataDetail?.chargers.filter(ch => ch.id !== element.id);

      this.initializeTable();
    }

  }

  userCanRetrieveDefaultChargersList() {

    if (!!this.dataDetail && !!this.dataDetail.e015Attributes) {
      if (!!this.dataDetail.e015Attributes.stationId && this.dataDetail.e015Attributes.stationId != '' &&
          (!this.dataDetail.chargers || this.dataDetail.chargers.length === 0)) {
        // Station id is not empty/null and
        // Charger.ts are undefined/empty

        return true;
      }
    }
    return false;
  }

  openStreetMapUrl(dataDetail: CustomerProductItemFull) {
    if (!!dataDetail.osmUrl) {
      window.open(dataDetail.osmUrl, '_blank');
    }
  }

  deleteChirpstackProductItem() {

    const dialogRef = this.dialog.open(AreUSureDeleteChirpstackDialogComponent, {
      width: '500px',
      data: `il productItem con EUI : ${this.selectedRow.devEui}`
    });

    dialogRef.afterClosed().subscribe(
        (res) => {
          if (res) {

            const cb = new DelCustomerProductItemChirpstackCB();
            cb.i.id = this.selectedRow.id;
            cb.i.eui = this.selectedRow.devEui.replace(/:/g, '');

            this.customerProductItemService.delCustomerProductItem(cb).subscribe(
                () => {
                  this.gmService.openSuccessSnackbar(this.translate.instant('PRODUCTITEM.DELETE_OK'));
                  this.refresh.emit(this.selectedRow);
                }, (error: string) => {
                  this.gmService.openErrorSnackbar(error);
                }
            );


          }
        }, error => {
          console.log(error);
        }
    );
  }

  getConnectorClass(element: ProductItemChargerRelationDTO): string {
    return element.chargerCount > 0 ? "connectorInstalled" : "connectorNotInstalled"
  }

  protected readonly AccessibilityTypes = AccessibilityTypes;
  protected readonly Object = Object;
}



/*--------------------------------
      PUT CUSTOMER COMPONENT
 -------------------------------*/

@Component({
  templateUrl: 'put-productItem-e015-charger-dialog.html',
  selector: 'app-put-productItem-e015-charger-dialog',
  styleUrls: ['../../common/dialog-style.css']
})
export class PutProductItemE015ChargerDialogComponent extends BaseDialogComponent<PutProductItemE015ChargerDialogComponent> {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    super();
  }

  insertProductItemCharger() {
    this.closeDialog(true);
  }

}

/*--------------------------------
     DELETE CIRPSTACK COMPONENT
 -------------------------------*/

@Component({
  templateUrl: '../../common/are-u-sure-delete-dialog.html',
  selector: 'app-are-u-sure-delete-dialog',
  styleUrls: ['../../common/dialog-style.css']
})
export class AreUSureDeleteChirpstackDialogComponent extends BaseDialogComponent<AreUSureDeleteChirpstackDialogComponent> {

  entity = "Dispositivo su ChirpsStack";


  constructor(@Inject(MAT_DIALOG_DATA) public customerTitle: string) {
    super();
  }

}

